import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/AuthService";
import { SubscriptionService } from "../../../services/subscriptionservice";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";

interface SubscriptionWithProduct {
  product: {
    tag: string;
  };
  subscriptionId: string;
}

@Component({
  selector: "dialog-ip-prefixes",
  templateUrl: "dialog-ip-prefixes.html",
  styleUrls: ["../../dialogs/dialog-affected-services/dialog-affected-services.scss"],
  imports: [AngularSvgIconModule, CommonModule, GuidPipe, TranslateModule],
})
export class DialogIPPrefixesComponent {
  protected editModus = false;
  private customerId = "";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      editModus: boolean;
      subscriptions;
      linkedSubscriptions;
    },
    public dialogRef: MatDialogRef<DialogIPPrefixesComponent>,
    public router: Router,
    public auth: AuthService,
    public subscriptionService: SubscriptionService,
  ) {
    this.customerId = this.auth.state.viewingCustomer.customerId;
    if (data.editModus) {
      this.editModus = true;
    }
  }

  isAvailable(subscription) {
    return this.subscriptionService.canViewSubscription(subscription);
  }

  closeDialog(): void {
    this.dialogRef.close({ forceScrollTop: false });
  }

  segueToService(subscription: SubscriptionWithProduct) {
    if (this.editModus) {
      this.router.navigate([`/subscription/IP/${subscription.product.tag}/${subscription.subscriptionId}`], {
        state: { action: "addPrefix", selectedPrefix: this.data.subscriptions },
      });
    } else {
      this.router.navigate([`/subscription/${subscription.subscriptionId}`]);
    }

    this.dialogRef.close({ forceScrollTop: true });
  }
}
